import { Paper, Stack, Typography, TextField, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DnsIcon from "@mui/icons-material/Dns";
import CheckIcon from "@mui/icons-material/Check";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import API from "../../../../api";

const NetworkAnomaly = ({ height, }) => {
  const apiRef = useGridApiRef();
  const [, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [viewMode, setViewMode] = useState("ip"); // "ip" | "name"
  const [menuAnchor, setMenuAnchor] = useState(null);

  const columns = [
    {
      field: "timestamp",
      headerName: "TIMESTAMP",
      valueFormatter: (p) => dayjs(p).format("YYYY-MM-DD"),
      width: 110,
      type: "string"
    },
    {
      field: "subtype",
      headerName: "REASON",
      type: "string",
      width: 130
    },
    {
      field: "score",
      headerName: "SCORE",
      type: "number",
      width: 100
    },
    {
      field: "local",
      headerName: "LOCAL",
      type: "string",
      width: 200,
      valueGetter: (value, row) => {
        if (viewMode !== "ip" && row.localName) return `${row.localName}:${row.localPort}`;
        else return `${row.localIp}:${row.localPort}`;
      }
    },
    {
      field: "processName",
      headerName: "PROCESS",
      type: "string",
      width: 130
    },
    {
      field: "remote",
      headerName: "REMOTE",
      type: "string",
      width: 200,
      valueGetter: (value, row) => {
        if (viewMode !== "ip" && row.remoteName) return `${row.remoteName}:${row.remotePort}`;
        else return `${row.remoteIp}:${row.remotePort}`;
      }
    }
  ].map(x => ({ ...x, disableColumnMenu: true }));

  useEffect(() => {
    API.getAgentNetworkAnomalies().then((res) => {
      setRows(res.data);
      setLoading(false);
    }).catch(() => {
      setRows([])
      setLoading(false);
    })
  }, []);

  const handleFilter = (value) => {
    apiRef.current.setQuickFilterValues(value ? [value] : []);
  }

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
    setMenuAnchor(null);
  };

  const handleToggleSearch = () => {
    if (showSearch) {
      apiRef.current.setQuickFilterValues([]);
    }
    setShowSearch(prev => !prev);
  };

  return (
    <Paper sx={{ backgroundColor: "#1e1e1e", borderRadius: "15px", height: height, overflow: "hidden", flexShrink: 0, p: 2 }}>
      <Stack direction={"column"} spacing={1} sx={{ height: "100%" }}>
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{ mb: 0.5 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888" }}>
            Network Anomalies
          </Typography>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            {showSearch && (
              <TextField
                autoFocus
                onChange={(e) => handleFilter(e.target.value)}
                size="small"
              />
            )}
            <IconButton size="small" onClick={handleToggleSearch} color={showSearch ? "primary" : "default"}>
              <SearchIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={(e) => setMenuAnchor(e.currentTarget)} color={viewMode === "name" ? "primary" : "default"}>
              <DnsIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
              <MenuItem onClick={() => handleViewModeChange("ip")}>
                <ListItemIcon>{viewMode === "ip" && <CheckIcon fontSize="small" />}</ListItemIcon>
                <ListItemText>Indirizzo IP</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleViewModeChange("name")}>
                <ListItemIcon>{viewMode === "name" && <CheckIcon fontSize="small" />}</ListItemIcon>
                <ListItemText>Nome macchina</ListItemText>
              </MenuItem>
            </Menu>
          </Stack>
        </Stack>
        <DataGridPro
          apiRef={apiRef}
          rows={rows}
          columns={columns}
          density="compact"
          localeText={{ noRowsLabel: "No anomalies detected" }}
          sx={{ flex: 1, minHeight: 0 }}
        />
      </Stack>
    </Paper>
  )
};

export default NetworkAnomaly;